import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { P, H6, Subtext } from '@contently/toolkit';

function CalculationBox({ id, title, subtext, value }) {
  return (
    <Fragment>
      <H6 style={{ marginBottom: '11px' }}>{title}</H6>
      <P style={{ marginBottom: '8px', fontSize: '28px' }} id={id}>
        {/* <ExtraExtraLarge>{value}</ExtraExtraLarge> */}
        {value}
      </P>
      <Subtext style={{ lineHeight: '15px' }}>{subtext}</Subtext>
    </Fragment>
  );
}

export default CalculationBox;

CalculationBox.propTypes = {
  title: PropTypes.string.isRequired,
  subtext: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  value: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/calculation_box.jsx